import { ThemedStyleFn } from '~src/hooks/useStyles';

export const styleFn: ThemedStyleFn = (theme) => ({
  cardWrapper: {
    width: '100%',
    minHeight: '65px',
    backgroundColor: 'white',
    border: '0.1px solid rgba(0, 0, 0, 10%)',
    borderRadius: '5px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '25px',
    padding: '10px 25px',
    height: '100%',
  },
  cardTitleWrapper: {
    display: 'flex',
    flexDirection: 'column',
    flex: 2,
    marginBlock: '15px',
    alignSelf: 'flex-start',
  },
  cardTitle: {
    fontSize: '14px',
    fontWeight: 'bold',
    cursor: 'pointer',
  },
  cardSubTitle: {
    marginTop: '-5px',
    fontSize: '12px',
    color: 'gray',
  },
  cardQuantity: {
    flex: 1,
    marginBlock: '15px',
  },
  cardUnitPriceWrapper: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    marginBlock: '15px',
  },
  cardSumPriceWrapper: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    marginBlock: '15px',
  },
  cardOptionWrapper: {
    flex: 0,
    fontSize: '12px',
  },
  cardGhost: {
    opacity: 0.4,
    border: '2px dashed gold',
  },
});
